module.exports = __webpack_public_path__ + "static/img/方胜磐石的愿景背景@2x.ed72c74.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/方胜磐石的愿景背景@2x.png
// module id = wixQ
// module chunks = 0